export enum SearchItemResultTypeValueDto {
  Profile = 'Profile',
  Research = 'Research',
  LatestVideos = 'Latest Videos',
  PCML = 'PCML',
}
